import { NEW_CENTER_URL } from 'config';
import { useContext, useState } from 'react';
import SessionContext from 'api/session/context';

export default function useModalNewVersion() {
  const {
    auth: { role },
  } = useContext(SessionContext);
  const [isModalNewVersion, setIsModalNewVersion] = useState(false);
  const [selectedNewModulePath, setSelectedNewModulePath] = useState('');

  const onNewAccept = (path: string) => {
    if (path) {
      window.open(`${NEW_CENTER_URL}/${role}/${selectedNewModulePath}`, '_blank', 'noopener,noreferrer');
    }
  };

  return {
    isModalNewVersion,
    setIsModalNewVersion,
    selectedNewModulePath,
    setSelectedNewModulePath,
    onNewAccept,
  };
}
